module.exports = __webpack_public_path__ + "img/whatsapp.68cfd36b.svg";